import quarterOfYear from "dayjs/plugin/quarterOfYear";
import { dayjs } from "@volca/ui/lib/date";

dayjs.extend(quarterOfYear);

export interface TimeRange {
  from: Date;
  to: Date;
  label: string;
}

export interface TimeRangePreset {
  label: string;
  getValue: () => TimeRange;
}

export const DEFAULT_PRESETS: TimeRangePreset[] = [
  {
    label: "This week",
    getValue: () => ({
      from: dayjs().startOf("week").toDate(),
      to: dayjs().endOf("week").toDate(),
      label: "This week",
    }),
  },
  {
    label: "This month",
    getValue: () => ({
      from: dayjs().startOf("month").toDate(),
      to: dayjs().endOf("month").toDate(),
      label: "This month",
    }),
  },
  {
    label: "Last month",
    getValue: () => ({
      from: dayjs().subtract(1, "month").startOf("month").toDate(),
      to: dayjs().subtract(1, "month").endOf("month").toDate(),
      label: "Last month",
    }),
  },
  {
    label: "Last 60 days",
    getValue: () => ({
      from: dayjs().subtract(60, "days").toDate(),
      to: dayjs().toDate(),
      label: "Last 60 days",
    }),
  },
  {
    label: "This quarter",
    getValue: () => ({
      from: dayjs().startOf("quarter").toDate(),
      to: dayjs().endOf("quarter").toDate(),
      label: "This quarter",
    }),
  },
  {
    label: "Last quarter",
    getValue: () => ({
      from: dayjs().subtract(1, "quarter").startOf("quarter").toDate(),
      to: dayjs().subtract(1, "quarter").endOf("quarter").toDate(),
      label: "Last quarter",
    }),
  },
  {
    label: "This year",
    getValue: () => ({
      from: dayjs().startOf("year").toDate(),
      to: dayjs().endOf("year").toDate(),
      label: "This year",
    }),
  },
];
